var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubtract(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40 20C40 31.0457 31.0457 40 20 40C8.9543 40 0 31.0457 0 20C0 8.9543 8.9543 0 20 0C31.0457 0 40 8.9543 40 20ZM29.2261 15.8238C29.9879 15.024 29.957 13.758 29.1571 12.9962C28.3573 12.2345 27.0913 12.2653 26.3295 13.0652L17.1958 22.6556L13.3531 18.6208C12.5913 17.8209 11.3253 17.79 10.5255 18.5518C9.72563 19.3136 9.69475 20.5795 10.4565 21.3794L15.7475 26.9349C16.125 27.3313 16.6485 27.5556 17.1958 27.5556C17.7432 27.5556 18.2666 27.3313 18.6441 26.9349L29.2261 15.8238Z",
    fill: "#07DFEF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubtract);
export default __webpack_public_path__ + "static/media/Subtract.2d2d48b403ce4d8e58db29347c9c394e.svg";
export { ForwardRef as ReactComponent };